import React from 'react'
import PropTypes from 'prop-types'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Slide from '@material-ui/core/Slide'

import Close from '@material-ui/icons/Close'

import Button from 'components/CustomButtons/Button.jsx'

import withStyles from '@material-ui/core/styles/withStyles'
import notificationsStyle from 'assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx'

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

function MentionsLegales ({ ...props }) {
  const { classes, open, handleClose } = props;

  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal
      }}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => handleClose()}
      aria-labelledby="classic-modal-slide-title"
      aria-describedby="classic-modal-slide-description"
    >
      <DialogTitle
        id="classic-modal-slide-title"
        disableTypography
        className={classes.modalHeader}
      >
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={() => handleClose()}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h4 className={classes.modalTitle}>Mentions légales</h4>
      </DialogTitle>
      <DialogContent
        id="classic-modal-slide-description"
        className={classes.modalBody}
      >
        <p>          
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque massa magna, tempor ut tempus in, egestas at ligula. Nullam euismod metus eget enim ornare, sed rutrum nunc mattis. Maecenas imperdiet nunc eu venenatis dapibus. In egestas urna eu pulvinar bibendum. Nam vehicula, purus a sagittis varius, mauris ipsum molestie magna, nec consequat velit sem vitae quam. Suspendisse hendrerit eget risus a eleifend. Aliquam facilisis augue at molestie facilisis. Pellentesque venenatis, felis et convallis euismod, risus lacus aliquam mauris, vitae molestie odio ligula vitae tortor. Cras tempus ante leo, vel lobortis risus consequat ut. Donec sed ligula at mi scelerisque aliquam. Sed eget eros pretium, pharetra eros ac, consequat nisi. Donec accumsan vel augue ut varius. Integer id sem at leo euismod lacinia sed sit amet arcu. Integer non dui non tellus pretium sagittis. Etiam malesuada in ex sed egestas. Duis id est lorem.
        </p>
        <p>
        Aliquam vitae viverra erat. Nulla facilisi. Morbi volutpat urna at aliquet consequat. Aenean eleifend, lorem eu vulputate ullamcorper, nisi velit mattis lectus, in luctus ex tellus at sem. Donec nulla odio, rutrum vitae eleifend a, luctus sit amet neque. Nam lorem tortor, egestas nec auctor luctus, mattis a ex. Sed sit amet placerat massa.
        </p>
        <p>
        Etiam arcu nisi, volutpat quis nisl vel, facilisis feugiat nibh. Sed pretium bibendum sapien, eget sodales nisl bibendum venenatis. Integer sit amet sodales dolor. Curabitur gravida ex eget eros rutrum, quis posuere metus mollis. Aliquam posuere euismod diam, at varius ante accumsan at. Nam at lacus ac massa fermentum sagittis id sed mauris. Cras vulputate pellentesque ligula id mollis. Cras non gravida orci. Aliquam erat volutpat.
        </p>
        <p>
        Fusce dapibus velit elit, id dignissim ex tempor sit amet. Fusce cursus at odio vel pretium. Vestibulum erat libero, molestie vitae ullamcorper non, varius nec ipsum. Fusce a lobortis ipsum. Donec vitae lacus nunc. Suspendisse tempus dignissim efficitur. Nullam faucibus in nunc in convallis. Cras elementum ante a dapibus semper. Suspendisse lobortis sapien nunc, a cursus mi tristique sed. Praesent vel dolor quis ante consectetur egestas. Maecenas euismod urna vitae pellentesque lacinia. Quisque in quam nibh.
        </p>
        <p>
        Quisque rhoncus purus vel consectetur feugiat. Sed pharetra egestas mi et ullamcorper. Sed eu nunc vel ligula dictum fermentum. Nulla eu libero sed elit ultricies consectetur at vel massa. Aenean non sem eu felis porta gravida non eget enim. Nulla porttitor erat at ipsum scelerisque elementum. Nullam tortor ligula, ultrices sed mi mattis, hendrerit luctus lectus. Maecenas ornare luctus neque, et molestie tortor pellentesque a. Duis pulvinar leo sed quam iaculis, sit amet fermentum dolor sodales. Cras tincidunt ornare dolor quis semper. Sed vitae hendrerit ante, nec lacinia diam. In hac habitasse platea dictumst.
        </p>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={() => handleClose()}
          color="info"
          round
        >
          J'ai lu et pris connaissance
        </Button>
      </DialogActions>
    </Dialog>
  )
}

MentionsLegales.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func
}

export default withStyles(notificationsStyle)(MentionsLegales)


// WEBPACK FOOTER //
// ./src/components/Footer/MentionsLegales.jsx